export const referencesListShowMore = (): void => {
  const allReferenceBlocks = document.querySelectorAll('.js-referencesList') as unknown as HTMLElement[]

  allReferenceBlocks.forEach((referenceBlock: HTMLElement) => {
    const showMoreButton = referenceBlock.querySelector('.js-referencesList-showMoreButton') as unknown as HTMLElement

    if (!showMoreButton) {
      return
    }
    showMoreButton.addEventListener('click', (e: Event): void => {
      setTimeout(() => {
        showMoreButton.remove()

        const referenceList = referenceBlock.querySelectorAll('.js-referencesList-singleReference') as unknown as HTMLElement[]

        referenceList.forEach((reference: HTMLElement) => {
          reference.classList.remove('d-none')
        })
      }, 150)
    })
  })
}
